<ng-container *ngIf="!ready">
  <div class="cff-loading">
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
  </div>
</ng-container>

<ng-container *ngIf="ready">

  <!-- ── TÍTULO ─────────────────────────────────────────────── -->
  <div mat-dialog-title class="cff-dlg-title">
    <div class="cff-dlg-title__left">
      <div class="cff-dlg-title__icon"><mat-icon>folder</mat-icon></div>
      <span>{{ conceptfamily?.uid ? 'Editar familia' : 'Nueva familia de conceptos' }}</span>
    </div>
  </div>

  <!-- ── CONTENIDO ─────────────────────────────────────────── -->
  <mat-dialog-content class="cff-dlg-content">

    <div class="cff-section">
      <div class="cff-section__head">
        <mat-icon>label</mat-icon>
        <span>Datos de la familia</span>
      </div>
      <div class="cff-section__body">

        <app-input inputType="text" placeholder="Nombre" name="conceptfamily.name" [isRequired]="true"
          [(ngModel)]="conceptfamily.name"></app-input>

        <app-input inputType="text" placeholder="Descripción" name="conceptfamily.description"
          [(ngModel)]="conceptfamily.description"></app-input>

        <mat-slide-toggle [(ngModel)]="conceptfamily.isDirectPosAccessTpv" name="isDirectPosAccessTpv"
          class="cff-toggle">
          Acceso directo TPV
        </mat-slide-toggle>

      </div>
    </div>

    <!-- Imagen -->
    <div class="cff-section cff-section--image">
      <div class="cff-section__head">
        <mat-icon>image</mat-icon>
        <span>Imagen</span>
      </div>
      <div class="cff-section__body">

        <ng-container *ngIf="conceptfamily.imageId != 0">
          <div class="cff-image-preview" *ngIf="imageReady">
            <img [src]="urlImage" class="cff-image-preview__img" />
          </div>
        </ng-container>

        <div class="cff-file-row">
          <label class="cff-file-btn">
            <mat-icon>attach_file</mat-icon> Seleccionar imagen
            <input type="file" class="cff-file-hidden" (change)="uploadImage($event)" accept="image/*" />
          </label>
          <button *ngIf="conceptfamily.imageId != 0" mat-stroked-button type="button"
            (click)="deleteImage()" class="cff-file-delete">
            <mat-icon>delete</mat-icon> Eliminar imagen
          </button>
        </div>

      </div>
    </div>

  </mat-dialog-content>

  <!-- ── ACCIONES ──────────────────────────────────────────── -->
  <mat-dialog-actions align="end" class="cff-dlg-actions">
    <button mat-stroked-button type="button" (click)="closeDialog()">
      <mat-icon>close</mat-icon> Cancelar
    </button>
    <button mat-flat-button class="cff-btn-save" type="button" (click)="save(conceptfamily)">
      <mat-icon>save</mat-icon> Guardar
    </button>
  </mat-dialog-actions>

</ng-container>
